const NoResultsDisplay = () => {
	return <div>There are no results to display.</div>
}

export default NoResultsDisplay
